import { createContext, memo, useContext, useMemo, useState } from 'react';
export const NavigationContext = createContext(null);
export const useNavigationContext = () => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigationContext must be used within a NavigationProvider');
    }
    return context;
};
export const NavigationProvider = memo(({ children }) => {
    const [open, setOpen] = useState(false);
    const context = useMemo(() => {
        return {
            open,
            setOpen,
        };
    }, [open, setOpen]);
    return (<NavigationContext.Provider value={context}>
			{children}
		</NavigationContext.Provider>);
});
